import { useFormikContext } from "formik";
import { FC, useState } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import EmailTemplatePreviewModal from './email-template-preview/EmailTemplatePreviewModal';
import { EmailTemplate } from "./email-template-step";
import { Button } from '../button/Button';
import { WizardStepLayout } from '../wizard/wizard-summary-layout';

interface Props {
    showPreview: boolean;
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    setSideBarStepDescription?: (newDescription) => void;
    setHideMainModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

const EmailTemplateForm: FC<Props> = ({ showPreview, onNext, onBack, setSideBarStepDescription = () => { }, setHideMainModal }) => {
    const task = '';
    const description = '';
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();
    const [isPreviewOpen, setIsPreviewOpen] = useState<boolean>(false);

    const onLocalNext = (event: any) => {
        if (values.emailAccountId && values.subject && values.body) {
            onNext({ ...event, task: task, description: description });
            setSideBarStepDescription(values.accountSetting)
        }
    }

    const isEnabled = () => {
        return values.emailAccountId.trim() && values.subject.trim() && values.body.trim() && values.disclaimer.trim();
    }

    const onPreviewEmail = () => {
        setIsPreviewOpen(true);
        setHideMainModal && setHideMainModal(true);
    }

    const onPreviewEmailClosed = () => {
        setIsPreviewOpen(false);
        setHideMainModal && setHideMainModal(false);
    }

    return (
        <>
            <WizardStepLayout
                onBack={onBack}
                onNext={onLocalNext}
                nextDisabled={!isEnabled()}
                tertiaryActions={showPreview ? (
                    <Button variant="tertiary" onClick={onPreviewEmail}>
                        {translate.byKey(TranslationKeys.previewEmail)}
                    </Button>
                ) : undefined}
            >
                <div className="pl-3">
                    <EmailTemplate />
                </div>
            </WizardStepLayout>
            <EmailTemplatePreviewModal isPreviewOpen={isPreviewOpen} onClose={onPreviewEmailClosed} />
        </>
    )
}

export default EmailTemplateForm;
